/**
 * @file_purpose  page for showing Update existing
 * @author Sucheta Singha
 * @Date_Created 27-08-2024
 * @Date_Modified 27-08-2024
 */
import React, { useState, useEffect } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import {
    CLabel,
    CSelect,
    CFormGroup,
    CButton,
    CSpinner,
    CInput
} from '@coreui/react'
import { ToastContainer, toast } from 'react-toastify';
import GeneralService from "src/apis/GeneralService";
import Constants from "src/Utility/Constants";
import RouteURL from "src/apis/ApiURL";


export default function UpdateCategoryExisting() {

    const history = useHistory();
    const [loadingData, setLoadingData] = useState(true);
    const [updateErrors, setUpdateErrors] = useState('');
    const [technologyErrors, setTechnologyErrors] = useState('');
    const [linkError, setLinkError] = useState('');
    const [fileExtensionError, setFileExtensionError] = useState('');

    const [isButtonDisable, setIsButtonDisable] = useState(true);
    const [updateOptions, setUpdateOptions] = useState([]);
    const [technologies, setTechnologies] = useState([]);
    let { service_id } = useParams();
    let { category_id } = useParams();  //1: Game, 2:App
    const [loader, setLoader] = useState(0);
    const [isTextFieldDisable, setIsTextFieldDisable] = useState(false);
    const [state, setState] = useState({
        link: '',
        attachments: '',
        technology: '',
        update_option: '',
    })
    const prevValue = JSON.parse(localStorage.getItem('update-category-existing'))
    const [fileExtension, setFileExtension] = useState();
    useEffect(() => {
        if (prevValue && updateOptions?.length > 0 && technologies?.length > 0) {
            // console.log(prevValue);
            setState({
                link: prevValue.link,
                attachments: prevValue.attachments,
                technology: prevValue.technology,
                update_option: prevValue.update_option,
            })
            setIsButtonDisable(false)
        }

    }, [(updateOptions?.length > 0 && technologies?.length > 0)])


    useEffect(() => {

        /**
      * @author Sucheta Singha
      * @Date_Created 27-08-2024
      * @Date_Modified 27-08-2024
      * @function async
      * @functionName loadUpdateExistingFields
      * @functionPurpose this function gets the list of categories.
      *
      * @functionParam {}
      * 
      * @functionSuccess Success status and message.
      *
      * @functionError {Boolean} error is there.
      * @functionError {String} message  Description message.
      */

        async function loadUpdateExistingFields() {
            let params = JSON.stringify({
                field_category_id: category_id
            })
            GeneralService.apiPostCallRequestWithoutToken(RouteURL.getUpdationMasterData, params)
                .then((res) => {
                    if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                        setUpdateOptions(res?.data?.update_options);
                        setTechnologies(res?.data?.game_engine);
                        setLoadingData(false)
                    }
                    else {
                        toast.error(res.message, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }
                }).catch(error => {
                    console.log(error)
                })

        }

        if (loadingData) {
            loadUpdateExistingFields()
        }

    }, [loadingData]);


    const handleChange = (e) => {
        var newValue
        if (e.target.type === "checkbox") {
            const { id, checked } = e.target
            newValue = checked ? 1 : 0
            setState(prevState => ({
                ...prevState,
                [id]: newValue
            }))
        }
        else {

            const { id, value } = e.target
            newValue = value
            setState(prevState => ({
                ...prevState,
                [id]: newValue
            }))

        }
        checkedValidation()
    }

    const handleChangeFile = (e) => {
        const { id } = e.target;
        console.log(e.target.files[0])
        setState(prevState => ({
            ...prevState,
            [id]: e.target.files[0]
        }))
        const fileChosen = document.getElementById('file-chosen1');
        fileChosen.textContent = start_and_end(e.target.files[0].name);
        const file_name = e.target.files[0].name
        const file_extension = ((file_name.split('.').pop().toLowerCase()).split("?"))[0];
        setFileExtension(file_extension)
    }

    const start_and_end = (str) => {
        if (str.length > 30) {
            return str.substr(0, 12) + '...' + str.substr(str.length - 10, str.length);
        }
        return str;
    }
    const checkedValidation = () => {
        if (!state.update_option && !state.technology) {
            setIsButtonDisable(true)
        } else {
            setIsButtonDisable(false)
        }
    }

    /* Validation Checking */
    const FormSubmitValidateForm = (e) => {
        e.preventDefault();
        if (formHandleValidation()) {
            formSubmitSubmitClick();
        }
    }

    const formHandleValidation = () => {
        let formIsValid = true;
        var expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
        var regex = new RegExp(expression);


        if (!state.update_option) {
            formIsValid = false;
            setUpdateErrors("Update option can not be empty");
        } else {
            setUpdateErrors('');
        }

        if (!state.technology) {
            formIsValid = false;
            if (category_id == "1") {
                setTechnologyErrors("Game engine can not be empty");
            } else {
                setTechnologyErrors("Technology can not be empty");
            }

        } else {
            setTechnologyErrors('');
        }


        if (state.link && !state.link.match(regex)) {
            formIsValid = false;
            setLinkError("Invalid URL")
        } else {
            setLinkError('')
        }

        if (state.attachments) {
            if (fileExtension != "mp4" && fileExtension != "mov" && fileExtension != "avi" && fileExtension != "mkv") {
                formIsValid = false;
                console.log(fileExtension);
                
                setFileExtensionError("Please select following file types: .mp4/.mov/.avi/.mkv")
            } else {
                setFileExtensionError("")
            }

        }



        return formIsValid;
    }


    const formSubmitSubmitClick = async (e) => {
        setIsButtonDisable(true);
        setLoader(1);
        let fieldDetails;
        fieldDetails = {
            link: state.link,
            attachments: state.attachments,
            technology: state.technology,
            update_option: state.update_option,
        }
        // console.log(fieldDetails);

        history.push({
            pathname: "/contact-form/update-category-existing",
            state: { fields: fieldDetails, field_category_id: category_id }
        });
        localStorage.setItem('update-category-existing', JSON.stringify(fieldDetails))
    }

    const GoBackClick = (e) => {
        e.preventDefault();
        history.goBack()
    }

    // const sendHeight = () => {
    //     // Send the height of the iframe content to the parent page
    //     window.parent.postMessage(document.body.scrollHeight, '*');
    //     // window.parent.postMessage(window.screen.availHeight, '*');
    // }

    // // Send height initially and on content changes
    // window.addEventListener('load', sendHeight);
    // window.addEventListener('resize', sendHeight);

    // const observer = new MutationObserver(sendHeight);
    // observer.observe(document.body, { childList: true, subtree: true });


    const sendHeight = () => {
        // Send the height of the iframe content to the parent page
        window.parent.postMessage(document.body.scrollHeight, '*');
    };

    // Debounce function to limit the number of times sendHeight is called
    const debounce = (func, delay) => {
        let timer;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(func, delay);
        };
    };

    // Create debounced version of sendHeight
    const debouncedSendHeight = debounce(sendHeight, 100);

    // Send height initially and on content changes
    window.addEventListener('load', debouncedSendHeight);
    window.addEventListener('resize', debouncedSendHeight);

    // Observe changes in the DOM with a slight delay to ensure rendering is complete
    const observer = new MutationObserver(debouncedSendHeight);
    observer.observe(document.body, { childList: true, subtree: true });

    return (
        <body style={{ backgroundColor: "#fff" }}>
            <div className="appoinment_hed">
                <h4>
                    LETS CALCULATE THE BALLPARK COST OF YOUR PROJECT
                </h4>
                <div className='row'>

                    <div className='col-sm-6 col-xl-6 col-lg-6 col-md-6 col-sm-12'>
                        <div className='ball_park'>
                            <div className='ball_park_num'>
                                <p>1</p>
                            </div>
                            <div className='ball_park_txt'>
                                <p>Fill in the required inputs below with relevant info.</p>
                            </div>
                        </div>
                    </div>

                    <div className='col-sm-6 col-xl-6 col-lg-6 col-md-6 col-sm-12'>
                        <div className='ball_park'>
                            <div className='ball_park_num'>
                                <p>2</p>
                            </div>
                            <div className='ball_park_txt'>
                                <p>Press "Calculate" button in order to get the ballpark price.</p>
                            </div>
                        </div>
                    </div>

                    {/* <div className='col-sm-4'>
                        <div className='ball_park'>
                            <div className='ball_park_num'>
                                <p>3</p>
                            </div>
                            <div className='ball_park_txt'>
                                <p>Contact us to get accurate <br />estimations.</p>
                            </div>
                        </div>
                    </div> */}
                </div>
                <div className="container">
                    {loader ?
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'absolute', width: '100%', marginTop: "10%" }}> <CSpinner
                            style={{ width: '4rem', height: '4rem', }}
                            color="danger"
                            variant="grow"
                            className="loader_z_index"
                        />
                        </div>
                        : ""}
                    <div className="ballpark_main">
                        <div className='row'>
                            <div className="col-md-6">
                                <div className='ballparkcost_inn'>
                                    <CLabel htmlFor="text-input">Select Update Option <b style={{ color: "#4A4B4C" }}>*</b></CLabel>
                                    <CSelect custom name="update_option" id="update_option" value={state.update_option} onChange={handleChange}
                                        required
                                        style={{ color: state.update_option ? "#000" : "#aba4a4" }}
                                    >
                                        <option value="">Select Option</option>
                                        {updateOptions && updateOptions.map((item, index) => (
                                            <option key={item.option_id} value={item.option_id}>{item.option_name}</option>
                                        ))}
                                    </CSelect>
                                    <span style={{ color: "red" }}>{updateErrors}</span>
                                </div>

                            </div>
                            <div className="col-md-6">
                                <div className='ballparkcost_inn'>
                                    <CLabel htmlFor="text-input">{category_id == 1 ? "Game" : "App"} Link</CLabel>
                                    <CInput
                                        type="text"
                                        placeholder={category_id == 1 ? "Share the game link" : "Share the app link"}
                                        value={state.link}
                                        name="link"
                                        id="link"
                                        onChange={handleChange}

                                    /><span style={{ color: "red" }}>{linkError}</span>

                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className='ballparkcost_inn'>
                                    <CLabel htmlFor="text-input">{category_id == 1 ? "Game" : "App"} Technology <b style={{ color: "#4A4B4C" }}>*</b></CLabel>
                                    <CSelect custom name="technology" id="technology" value={state.technology} onChange={handleChange} required
                                        style={{ color: state.technology ? "#000" : "#aba4a4" }}
                                    >
                                        {category_id == 1 ?
                                            <option value="">Select Engine</option>
                                            :
                                            <option value="">Select Technology</option>
                                        }
                                        {technologies && technologies.map((item, index) => (
                                            <option key={item.game_engine_id} value={item.game_engine_id}>{item.game_engine_name}</option>
                                        ))}
                                    </CSelect>
                                    <span style={{ color: "red" }}>{technologyErrors}</span>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className='ballparkcost_inn'>
                                    <CLabel htmlFor="text-input" >{category_id == 1 ? "Game" : "App"} Video </CLabel>
                                    <div className='ballparkcost_inn_file'>


                                        <input type="file" hidden name="attachments" id="attachments" accept="video/mp4,video/x-m4v,video/*"
                                            placeholder="Attachment" onChange={handleChangeFile}
                                        // disabled={isTextFieldDisable ? true : false} 
                                        />
                                        <label className='meeting_book_choose' for="attachments">Choose File</label>
                                        <span id="file-chosen1"> Upload video</span>
                                        {/* <input type="file" name="attachments" id="attachments" accept=".pdf,.doc,.docx,.xls,.xlsx,.zip,image/*,video/*"
                                    placeholder="Attachment" onChange={handleChangeFile} /> */}
                                     <span className='video_link_error' style={{ color: "red" }}>{fileExtensionError}</span>
                                    </div>
                                </div>
                            </div>
                        </div>




                    </div>
                </div>
                <div className="booking_btns_sec">
                    <div className="atten_sec1 col-12 text-center">
                        <CButton className="cancel" onClick={GoBackClick}
                            style={{ marginRight: 10 }}
                        ><i class="fa-solid fa-chevron-left"></i> Back</CButton>

                        <CButton className="save"
                            onClick={FormSubmitValidateForm}
                            disabled={isButtonDisable ? true : false}
                            style={{ background: isButtonDisable ? '#DFDFDF' : '#E84C3D' }}
                        >
                            Calculate
                            <i class="fa-solid fa-angle-right" style={{ right: 18, top: 11 }}></i>
                        </CButton>

                    </div>
                </div>
                {/* <div className="comp_off_inn">
                    <div className="atten_sec1 col-12 text-center">
                        <CButton className="cancel" onClick={GoBackClick}
                            style={{ marginRight: 10 }}>Back</CButton>

                        <CButton className="save"
                            onClick={FormSubmitValidateForm}
                            disabled={isButtonDisable ? true : false}
                        >
                            Calculate
                        </CButton>
                    </div>
                </div> */}
            </div>
        </body>

    )
}



